import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttendanceOverview } from '../models/AttendanceOverview';
import { BaseResponse } from '../models/response/BaseResponse';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService extends HttpService {
  getOverview(): Observable<BaseResponse<AttendanceOverview>> {
    return this.get('attendance/overview');
  }
}
